import { Preferences } from '@capacitor/preferences';

export const iosSignificantUpdateId = 'ios-age-assurance-rollout-2026-04-v1';

const getNormalizedAppName = (appName: string) => (
  appName.toLowerCase().replace(/[^a-z0-9]+/g, '-')
);

const getAdultAcknowledgmentStorageKey = (appName: string) => (
  `ios_significant_update_adult_ack_${getNormalizedAppName(appName)}_${iosSignificantUpdateId}`
);

export const getIosSignificantUpdateDescription = (appName: string) => (
  `${appName} now uses app store age assurance to determine whether this update requires parent or guardian approval before access continues.`
);

export const hasStoredIosAdultAcknowledgment = async (appName: string) => {
  const response = await Preferences.get({
    key: getAdultAcknowledgmentStorageKey(appName),
  });

  return Boolean(response.value);
};

export const setStoredIosAdultAcknowledgment = async (appName: string) => {
  await Preferences.set({
    key: getAdultAcknowledgmentStorageKey(appName),
    value: new Date().toISOString(),
  });
};

export const clearStoredIosAdultAcknowledgment = async (appName: string) => {
  await Preferences.remove({
    key: getAdultAcknowledgmentStorageKey(appName),
  });
};
